class CityAtcNotificationModal extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('.city--modal');
    this.klaviyoFormIds = {
      ar: 'WNVwJu',
      en: 'V6M25A'
    };
  }

  open() {
    const locForm = this.querySelector('localization-form');
    locForm?.removeAttribute('data-pending-city');
    locForm?.setCurrentCityInElement?.();
    this.modal?.classList.add('city--modal--active');
  }

  close() {
    this.modal?.classList.remove('city--modal--active');
  }

  getCurrentLanguage() {
    const htmlLang = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    if (htmlLang.startsWith('ar')) return 'ar';
    if (htmlLang.startsWith('en')) return 'en';

    const shopifyLocale = (window.Shopify?.locale || '').toLowerCase();
    if (shopifyLocale === 'ar' || shopifyLocale === 'en') return shopifyLocale;

    const preferredLanguage = (localStorage.getItem('preferred_language') || '').toLowerCase();
    if (preferredLanguage === 'ar' || preferredLanguage === 'en') return preferredLanguage;

    return 'en';
  }

  getKlaviyoFormId() {
    const lang = this.getCurrentLanguage();
    return this.klaviyoFormIds[lang] || this.klaviyoFormIds.en;
  }

  triggerKlaviyoForm() {
    const formId = this.getKlaviyoFormId();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  }

  resolvePendingCity(locForm) {
    let pendingCity = locForm?.getAttribute('data-pending-city');

    if (!pendingCity) {
      pendingCity = (localStorage.getItem('selectedCity') || window.defaultCity || 'RIYADH').trim();
      if (pendingCity !== 'RIYADH' && pendingCity !== 'OTHER CITY') {
        if (
          pendingCity === window.locations?.OTHER_CITY ||
          pendingCity === window.locations?.OTHER_CITIES ||
          pendingCity === window.locations?.JEDDAH ||
          pendingCity === window.locations?.DOHA
        ) {
          pendingCity = 'OTHER CITY';
        } else if (pendingCity === window.locations?.RIYADH) {
          pendingCity = 'RIYADH';
        }
      }
    }

    return pendingCity;
  }

  connectedCallback() {
    this.querySelector('.city--modal__close')?.addEventListener('click', () => this.close());
    this.querySelector('.city--modal__backdrop')?.addEventListener('click', () => this.close());

    this.addEventListener('keyup', (event) => {
      if (event.code === 'Escape') this.close();
    });

    const confirmButton = this.querySelector('.city--modal__confirm button');
    if (confirmButton) {
      confirmButton.addEventListener('click', () => {
        const locForm = this.querySelector('localization-form');
        const pendingCity = this.resolvePendingCity(locForm);

        if (locForm && typeof locForm.applyCitySelection === 'function') {
          locForm.applyCitySelection(pendingCity);
        }

        if (pendingCity === 'OTHER CITY') {
          sessionStorage.removeItem('openKlaviyoLocationForm');
          this.close();
          this.triggerKlaviyoForm();
        } else {
          this.close();
        }
      });
    }
  }
}

customElements.define('city-atc-notification-modal', CityAtcNotificationModal);
